import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion as Accordion,
  AccordionDetails as AccordionDetails,
  AccordionSummary as AccordionSummary} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  icon: {
    padding: theme.spacing(1),
  },
  panelDetails: {
    padding: theme.spacing(1),
  },
  panelRoot: {
    '&.Mui-expanded': {
      margin: theme.spacing(1, 0),
    },
  },
  summaryContent: {
    '&.Mui-expanded': {
      margin: theme.spacing(1, 0),
    },
    margin: 0,
  },
  summaryRoot: {
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
  },
}));

const SimulatorExpansionPanel = props => {
  const { classes } = useStyles();
  return (
    <Accordion defaultExpanded classes={{root: classes.panelRoot}}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        classes={{
          content: classes.summaryContent,
          expandIcon: classes.icon,
          root: classes.summaryRoot,
        }}
      >
        {props.title}
      </AccordionSummary>
      <AccordionDetails className={classes.panelDetails}>
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
};

SimulatorExpansionPanel.propTypes = {
  children: PropTypes.any,
  title: PropTypes.node,
};

export default SimulatorExpansionPanel;
